import Model from '@/models/Model'

export class Page extends Model {
	public id !: number

	// Default attributes that define the "empty" state.
	public defaults() {
		return {
			id: null,
			name: '',
			title: '',
			description: '',
			keywords: '',
			content: '',
			plain: '',
			main: false,
			label: '',
			parent: 0,
		}
	}

	// Attribute mutations.
	public mutations() {
		return {
			id: (id: any) => Number(id) || null,
		}
	}

	// Route configuration
	public routes() {
		return {
			create: '/pages',
			fetch: '/pages/{id}',
			patch: '/pages/{id}',
			delete: '/pages/{id}',
		}
	}

	public options() {
		return {
			patch: true,
		}
	}

	get route() {
		return { name: 'edit-page', params: { id: this.id } }
	}

	get errorArray() {
		const errors = this.getErrors()
		const errorsArray: any = []
		Object.keys(errors).forEach((property) => {
			errorsArray.push(errors[property])
		})
		if (errorsArray.length === 0) {
			return 'Failed to save page.'
		}
		return errorsArray
	}
}
